import React from "react";
import ScrollRevealText from "../Comman/ScrollRevealText";

export default function TribeOCryptoFestival() {
  return (
    <>
      <div>
        {/* about area start */}
        <div className="tp-about-2-area  pb-120">
          <div className="container container-1480">
            <div className="row justify-content-center">
              <div className="">
                <div className="tp-about-2-title-box tp-btn-trigger tp-btn-bounce mb-70 text-start text-xl-center">
                  <ScrollRevealText text="Redefining Digital Ownership with Real-World Value" />
                  <p className="text-center">
                    Not just another NFT Kryptogram is a groundbreaking shift in
                    blockchain-powered real estate and entertainment
                  </p>
                </div>
              </div>
            </div>
            <div className="row align-items-center">
              <div
                className="col-xl-4 col-lg-6 col-md-6 "
                style={{
                  backgroundPosition: "50% 50%",
                  backgroundSize: "cover",
                  backgroundImage: "url(assets/img/one/shape-bg.png)",
                }}
              >
                <div className="tp-about-2-thumb-box p-relative">
                  <div className="tp-about-2-thumb-main">
                    <img src="assets/img/one/elite_networking_one.png" alt="" />
                  </div>
                  <div className="tp-about-2-thumb-inner">
                    <img src="assets/img/one/elite_networking_two.png" alt="" />
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-12 order-0 order-xl-1">
                <div className="tp-about-2-content">
                  <h3 className="text-yellow-new">True Utility</h3>
                  <p className="mb-30">
                    Unlike traditional NFTs, Kryptogram provides
                    <span className="fw-bold">&nbsp;tangible value</span>
                    &nbsp; with
                    <span className="fw-bold">
                      &nbsp;real-world land ownership and festival
                      participation.
                    </span>
                    &nbsp;
                  </p>
                </div>
                <div className="tp-about-2-content">
                  <h3 className="text-yellow-new">Limited Supply</h3>
                  <p className="mb-30">
                    <span className="fw-bold">Only 55,200 NFTs available</span>
                    &nbsp;Ensuring
                    <span className="fw-bold">
                      Scarcity-driven appreciation
                    </span>
                    &nbsp; for early adopters.
                  </p>
                </div>
                <div className="tp-about-2-content">
                  <h3 className="text-yellow-new">Exclusive Community</h3>
                  <p className="mb-30">
                    Kryptogram NFT holders get priority access to
                    <span className="fw-bold">
                      future blockchain investment opportunities
                    </span>
                    &nbsp; and
                    <span className="fw-bold"> private events.</span>
                  </p>
                </div>
              </div>
              <div className="col-xl-2 col-lg-6 col-md-6 order-1">
                <div className="tp-about-2-right-thumb text-end">
                  <img
                    data-speed="auto"
                    src="assets/img/one/elite_networking_three.png"
                    alt=""
                    data-lag={0}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
